import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

class Ad extends PureComponent {

    render = () => {
        const { children, className, id } = this.props;
        return (
            <div className={className} data-id={id} id={id}>
                {children}
            </div>
        );
    };

}

Ad.propTypes = {
    className: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    children: PropTypes.object
};

export { Ad };
